import fetch from "@/uilts/request";


// 深圳风控报告
export default {
    /**
     * 创建授权书
     */
    async createSingContract(data) {
        return await fetch.post("ZhiCha/createSingContract", data)
    },


    /**
     * 获取风控结果
     */

    async queryZuWu(data){
        return await fetch.post("ZhiCha/queryZuWu", data)
    },

    async getFileDownload(data){
        return await fetch.post("ZhiCha/getFileDownload", data)
    }






}
